var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuesta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 50,
    viewBox: "0 0 196 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.6363 22.6714H84.045C82.3347 22.6714 80.9534 24.0528 80.9534 25.763C80.9534 27.4733 82.3347 28.8547 84.045 28.8547H89.6363C91.3465 28.8547 92.7279 27.4733 92.7279 25.763C92.7279 24.0528 91.3465 22.6714 89.6363 22.6714Z",
    fill: "url(#paint0_linear_402_9381)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3833 17.1909C75.3833 17.3006 75.4052 17.3883 75.4271 17.476C75.4271 17.4102 75.4052 17.3006 75.3833 17.1909Z",
    fill: "url(#paint1_linear_402_9381)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9086 17.7163C75.8867 17.1681 76.3252 16.7077 76.8734 16.7077C76.8953 16.7077 76.8953 16.7077 76.9172 16.7077H77.0927L98.7999 16.6858C100.51 16.6858 101.892 15.3044 101.87 13.5941C101.87 11.8839 100.488 10.5244 98.7999 10.5244H75.9086C72.51 10.5244 69.7473 13.2872 69.7473 16.6858V28.0656C69.7473 32.7579 65.7347 35.0602 61.7222 35.0602C57.7096 35.0602 53.6532 32.736 53.6532 28.0656V15.0632C52.5569 16.7515 50.2766 17.2339 48.5882 16.1376C48.1497 15.8526 47.755 15.4579 47.47 15.0193V28.0656C47.47 36.7924 54.618 41.1557 61.7222 41.1557C68.8264 41.1557 75.9306 36.8143 75.9306 28.0656V18.1548M75.9086 17.7163V18.1768Z",
    fill: "url(#paint2_linear_402_9381)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M161.422 12.4764C161.422 11.402 161.883 10.3934 162.694 9.69171H132.15V9.64786L119.126 9.604C112.789 9.69171 106.979 12.2352 106.979 18.4842C106.979 25.3472 113.995 26.8601 119.718 28.088C123.818 28.9432 127.283 29.7106 127.283 32.276C127.283 34.4686 124.739 35.4553 121.406 35.4553H86.0388C87.5956 36.749 87.8149 39.0513 86.5212 40.6081C86.3896 40.7835 86.2362 40.9369 86.0607 41.0685H120.705C127.721 41.0685 134.08 38.4812 134.08 32.1006C134.08 25.106 126.932 23.6589 121.165 22.5845C117.109 21.7732 113.71 21.0935 113.71 18.6596C113.71 16.2258 116.254 15.2391 119.455 15.2391H148.968V37.9988C148.968 39.7091 150.349 41.0904 152.06 41.0904C153.77 41.0904 155.151 39.7091 155.151 37.9988V15.2391H162.628C161.883 14.5375 161.422 13.5288 161.422 12.4764Z",
    fill: "url(#paint3_linear_402_9381)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M192.053 32.7805C192.645 32.7805 193.237 32.9121 193.785 33.1971L192.82 31.0483L184.466 12.6301L184.445 12.5643C183.765 11.0295 182.383 9.93314 180.717 9.62617C180.125 9.51654 179.511 9.51654 178.919 9.62617C177.318 9.91121 175.937 10.9637 175.257 12.4547L175.17 12.6739L162.913 39.6655L161.005 43.8753L160.874 44.2042C160.238 45.7391 160.983 47.5151 162.518 48.1291C164.053 48.7649 165.829 48.0194 166.443 46.4846V46.4407L169.425 39.6435L178.634 19.4492L179.796 16.8838L180.98 19.4492L185.782 29.9082H178.481C177.011 29.9739 175.893 31.2018 175.959 32.6709C176.025 34.0303 177.121 35.1267 178.481 35.1925H188.15L188.347 35.6091C188.764 33.9646 190.299 32.7805 192.053 32.7805Z",
    fill: "url(#paint4_linear_402_9381)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2467 0C10.0422 0 0.942721 9.20913 0.942721 20.5451C0.920794 27.8247 4.736 34.5561 10.9851 38.2836C14.0109 40.0816 17.4534 41.0683 20.9835 41.1122H21.5317C26.4871 41.2218 31.0697 43.831 33.679 48.0409C34.1614 49.5319 35.762 50.3432 37.253 49.8608C37.8889 49.6635 38.437 49.225 38.7878 48.6549C39.3799 47.712 39.3579 46.528 38.744 45.6071C38.3055 44.8177 37.8012 44.0722 37.2749 43.3487C35.6962 41.3095 33.7448 39.5773 31.5302 38.2617C28.5043 36.4637 25.0619 35.499 21.5317 35.4551H20.9835C17.3218 35.3894 13.8136 33.9422 11.1605 31.4207C8.17846 28.5921 6.49012 24.6454 6.51205 20.5232C6.51205 12.2788 13.1119 5.59125 21.2686 5.59125C29.4252 5.59125 36.0032 12.2788 36.0032 20.5232C36.0032 23.1544 35.3235 25.7417 34.0079 28.044C35.9593 27.4958 37.9766 28.636 38.5028 30.5874C38.5467 30.7848 38.5905 30.9821 38.6124 31.1795C40.542 27.9782 41.5725 24.2945 41.5506 20.5451C41.5287 9.20913 32.4511 0 21.2467 0ZM38.8536 46.221C38.7878 46.1114 38.744 45.9798 38.6782 45.8702C38.744 45.9798 38.8098 46.0895 38.8536 46.221Z",
    fill: "url(#paint5_linear_402_9381)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6792 45.8706C38.745 45.9802 38.7888 46.1118 38.8546 46.2214C38.8108 46.0899 38.745 45.9802 38.6792 45.8706Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6792 45.8706C38.745 45.9802 38.7888 46.1118 38.8546 46.2214C38.8108 46.0899 38.745 45.9802 38.6792 45.8706Z",
    fill: "url(#paint6_linear_402_9381)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5634 15.7435C52.0529 15.7435 53.2604 14.5361 53.2604 13.0466C53.2604 11.5571 52.0529 10.3496 50.5634 10.3496C49.0739 10.3496 47.8665 11.5571 47.8665 13.0466C47.8665 14.5361 49.0739 15.7435 50.5634 15.7435Z",
    fill: "#FFAC2F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9496 34.4241C36.5118 34.4241 37.7781 33.1578 37.7781 31.5956C37.7781 30.0335 36.5118 28.7671 34.9496 28.7671C33.3875 28.7671 32.1211 30.0335 32.1211 31.5956C32.1211 33.1578 33.3875 34.4241 34.9496 34.4241Z",
    fill: "#FFAC2F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7161 41.0689C85.2419 41.0689 86.4788 39.832 86.4788 38.3062C86.4788 36.7804 85.2419 35.5435 83.7161 35.5435C82.1903 35.5435 80.9534 36.7804 80.9534 38.3062C80.9534 39.832 82.1903 41.0689 83.7161 41.0689Z",
    fill: "#FFAC2F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M165.107 15.2389C166.633 15.2389 167.869 14.0019 167.869 12.4761C167.869 10.9503 166.633 9.71338 165.107 9.71338C163.581 9.71338 162.344 10.9503 162.344 12.4761C162.344 14.0019 163.581 15.2389 165.107 15.2389Z",
    fill: "#FFAC2F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M192.053 39.6656C193.712 39.6656 195.057 38.3207 195.057 36.6616C195.057 35.0026 193.712 33.6577 192.053 33.6577C190.394 33.6577 189.049 35.0026 189.049 36.6616C189.049 38.3207 190.394 39.6656 192.053 39.6656Z",
    fill: "#FFAC2F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_402_9381",
    x1: 86.8362,
    y1: 22.8948,
    x2: 86.8362,
    y2: 29.0701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D359FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A1AF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_402_9381",
    x1: 75.419,
    y1: 10.47,
    x2: 75.419,
    y2: 41.1229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A268AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6951A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_402_9381",
    x1: 74.6647,
    y1: 10.5127,
    x2: 74.6647,
    y2: 41.1468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D359FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A1AF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_402_9381",
    x1: 124.375,
    y1: 9.16014,
    x2: 124.375,
    y2: 40.6227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D359FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A1AF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_402_9381",
    x1: 177.209,
    y1: 10.3463,
    x2: 177.209,
    y2: 49.1064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D359FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A1AF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_402_9381",
    x1: 21.2432,
    y1: 0.229483,
    x2: 21.2432,
    y2: 50.2338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D359FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A1AF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_402_9381",
    x1: 38.7655,
    y1: 0.229707,
    x2: 38.7655,
    y2: 50.2465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A268AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6951A1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuesta);
export default __webpack_public_path__ + "static/media/questa.8cfdede8fc2b00893f2e2ba099e50ff3.svg";
export { ForwardRef as ReactComponent };